import type { ModuleRegisterFunction } from "../moduleRegisterFunction.ts";

export const registerMswPages: ModuleRegisterFunction = runtime => {
    // Ony register these pages if we are in an MSW environment. Otherwise, they are not necessary as we use
    // an external auth provider.
    if (runtime.isMswEnabled) {
        runtime.registerRoute(
            {
                $visibility: "public",
                path: "/login",
                lazy: async () => {
                    const { LoginPage } = await import("./pages/LoginPage.tsx");

                    return {
                        element: <LoginPage />
                    };
                }
            },
            { hoist: true }
        );

        runtime.registerRoute(
            {
                $visibility: "public",
                path: "/logout",
                lazy: async () => {
                    const { LogoutPage } = await import("./pages/LogoutPage.tsx");

                    return {
                        element: <LogoutPage />
                    };
                }
            },
            { hoist: true }
        );
    }
};
